<template>

    <section>
        <!-- ここから -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center">
            <div class="main"><span>ダッシュボード</span></div>
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            DashBoardCardWrap
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="ly_dashboard-card-wrap">

            <!--お知らせ-->
            <div class="row flex _left">
                <div class="block _min-h">

                    <div class="md_common-bl">

                        <h2 class="title">
                            <p>お知らせ</p>
                            <div class="link">
                                <a href="">MORE</a>
                            </div>
                            <div class="label">News</div>
                        </h2>

                        <!--Inner-->
                        <div class="inner">

                            <ul class="list_common _link">

                                <!--Item-->
                                <li class="_unread _operating"><!--FIXME:components 未読の場合は _unread の ヘルパークラスを付与-->
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li class="_operating">
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li>
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li>
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li class="_unread"><!--FIXME:components 未読の場合は _unread の ヘルパークラスを付与-->
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li>
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li>
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>
                                <!--Item-->
                                <li>
                                    <a href="">
                                        <div class="date"><span>2021.09.01</span></div>
                                        <div class="detail">
                                            <span>お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。お知らせタイトルが入ります。</span>
                                        </div>
                                    </a>
                                </li>

                            </ul>

                        </div><!--/.inner-->

                    </div>
                </div>
            </div><!--/.row-->

        </div><!--/.ly_dashboard-card-wrap-->

        <!-- ここまで -->
    </section>

</template>
